import {unwrapAPIError} from 'utils'
import {
  AdminImportConsentUrlRequest,
  AdminImportConsentUrlResponse,
  GenericDataResponse,
} from 'interfaces'
import {EndPoints, HttpMethods} from '../HTTP/HTTP.types'
import {requestHandler} from '../HTTP'

const getAdminImportConsentUrl = async (
  params: AdminImportConsentUrlRequest,
): Promise<GenericDataResponse<AdminImportConsentUrlResponse>> => {
  try {
    const res = await requestHandler<
      GenericDataResponse<AdminImportConsentUrlResponse>
    >({
      method: HttpMethods.GET,
      url: EndPoints.AdminImportConsentUrl,
      options: {params},
    })
    return res.data
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

export const AdminService = {
  getAdminImportConsentUrl,
}
